module.exports = __webpack_public_path__ + "static/media/Howard, Burlingame, CA1.13407b2f.jpg";